import { useQueries } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { Constants } from 'constants/constants'
import { fetchSalesLocation } from 'queries/sales/location'
import { SalesFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useSalesLocationHistorical({
    env,
    accessToken,
    location,
    filters,
    dynamicSubPath,
}: SalesFetchProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const timeDimensions = Constants.TIME_DIMENSION_HISTORICAL_GF_ARRAY

    const queries = timeDimensions.map((dimension) => {
        return {
            queryKey: [
                QueryKeys.SALES_LOCATION_HISTORICAL,
                location,
                dimension,
            ],
            queryFn: () =>
                fetchSalesLocation({
                    env,
                    accessToken,
                    filters: { ...filters, time_dimension: dimension },
                    dynamicSubPath,
                    trackEvent,
                }),
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        }
    })

    return useQueries({
        queries,
    })
}
